import {IMapEnum, IMapEnumElement, IMapEnumElements} from "./interface";
import {isBlank} from "../../helpers/stringHelper";
import {MapEnumElement} from "./MapEnumElement";
import {BaseMapEnum} from "./BaseMapEnum";
import {getTypeOfObject, typeOfObject} from "../../helpers/objectHelper";

export abstract class MapEnum<T extends IMapEnumElement> extends BaseMapEnum implements IMapEnum<T> {

    protected declare _id: number;
    protected declare _name: string;
    protected declare _fieldName: string;
    protected declare _parent: IMapEnumElement;
    elements: IMapEnumElements<T>;

    constructor(...keys: T[]) {
        super()
        this.elements = {};
        keys.forEach((key, i) => {
            this.elements[key.id] = key;
        });
        Object.freeze(this.elements);
    }

    get id(): number {
        return this._id;
    }

    set id(id: number) {
        if (id !== undefined && this.elements[id]) {
            this._id = id;
            this._name = this.elements[id].name;
            this._fieldName =this.elements[id].fieldName ?? "";
        }

    }

    get name(): string {
        return this._name;
    }

    set name(name: string) {
        if (!isBlank(name)) {
            const result = this.getIdByName(name);
            if (result) {
                this._id = result;
                this._name = this.elements[result].name;
            }
        }

    }
    get fieldName(): string {
        return this._fieldName;
    }
    set fieldName(fieldName: string) {
        if (!isBlank(fieldName)) {
            const result = this.getIdByFieldName(fieldName);
            if (result) {
                this._id = result;
                this._name = this.elements[result].name;
                this._fieldName =this.elements[result].fieldName ?? "";
            }
        }

    }
    get parents(): IMapEnumElement {
        return this._parent;
    }

    * [Symbol.iterator]() {
        for (let key of Object.keys(this.elements)) yield Number(key);
    }


    toString():string {
        return this._name ?? (this._id ? this.getNameByid(this._id) : "");
    }

    getNameByid(id: number): string {
        return this.elements[id]?.name ?? undefined;
    }
    getFieldNameByid(id: number): string {
        return this.elements[id]?.name ?? undefined;
    }

    getIdByName(name: string): number | undefined {
        const keys = Object.keys(this.elements);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i] as any;
            if (this.elements[key].name === name) {
                return Number(key);
            }
        }
        return undefined;
    }
    getIdByFieldName(fieldName: string): number | undefined {
        const keys = Object.keys(this.elements);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i] as any;
            if (this.elements[key].fieldName === fieldName) {
                return Number(key);
            }
        }
        return undefined;
    }

/*    equals(mapEnum: IMapEnumElement): boolean {
        if (mapEnum?.owner) {
            if (this.constructor !== mapEnum.owner) {
                return false;
            }
        }
        if (mapEnum?.id) {
            return this._id === mapEnum.id;
        } else {
            return false;
        }
    }*/

    get [Symbol.toStringTag]() {
        return "MapEnum";
    }

/*    [Symbol.toPrimitive](hint: "default"): string;
    [Symbol.toPrimitive](hint: "string"): string;
    [Symbol.toPrimitive](hint: "number"): number;
    [Symbol.toPrimitive](hint: string): string | number;
    [Symbol.toPrimitive](hint: "default" | "string" | "number" | string): string | number {
        if (hint === 'number') {
            return this?.id ?? -1;
        } else {
            return this?._fieldName ?? "";
        }

    }*/
    protected  static createElement() {
        const  enums = this as any;
        let strings = Object.keys(enums);
         strings.forEach((key) => {
             if(getTypeOfObject(enums[key]) === typeOfObject){
                 const result = (enums[key] as IMapEnumElement)
                 if(result.id !== undefined){
                     enums[key] = new MapEnumElement(key,result.id,result.name,enums,result.parent);
                 }

             }

        });

    }
    protected static createEnum<Y extends MapEnum<any>>(): Y {
        const  enums = this as any;
        let strings = Object.keys(enums);
        const mapEnumElement: IMapEnumElement[] = strings.map((key) => {
            const result = (enums[key] as IMapEnumElement)
            result.fieldName = key;
            return result;
        });
        return new enums(...mapEnumElement) as Y;
    }

    protected static createEnumWithId<Y extends MapEnum<any>>(id: number): Y {
        let enumResult = this.createEnum<Y>();
        enumResult.id = id;
        return enumResult;
    }

    protected static createEnumWithName<Y extends MapEnum<any>>(name: string): Y {
        let enumResult = this.createEnum<Y>();
        enumResult.name = name;
        return enumResult;
    }
    protected static createEnumWithFieldName<Y extends MapEnum<any>>(name: string): Y {
        let enumResult = this.createEnum<Y>();
        enumResult.fieldName = name;
        return enumResult;
    }
    static Instance<T extends MapEnum<any>>(): any {
        return this.createEnum<T>();
    }
    static InstanceWithValue(value:number): any {
        return this.createEnumWithId<any>(value);
    }
    static InstanceWithName(name:string): any {
        return this.createEnumWithName<any>(name);
    }
    static InstanceWithFieldName(fieldName:string): any {
        return this.createEnumWithFieldName<any>(fieldName);
    }
}